import { useMutation } from '@tanstack/react-query';
import { Announce_Payload_Type, announceContent } from '../axiosNetworkRequest/announce';
import { useSelector } from 'react-redux';
import { ReduxRootStateType } from '../../redux/store';
import { track } from '../../utils/MixpanelHelper';
import useNotification from '../../hooks/useNotification';
import { API_Error_Type } from '../axiosClient/axiosClient';

export const useAnnounceContent = () => {
  const userInfo = useSelector((state: ReduxRootStateType) => state.user.user_info);
  const { setMessage, setSeverity, handleSnackbarOpen } = useNotification();
  return useMutation({
    mutationFn: (payload: Announce_Payload_Type) => announceContent(payload),
    onSuccess: (_, variables) => {
      track('Announcement Sent', {
        'File Name':       variables.file_name,
        'Department':      variables.dept_name,
        'Recipient Count': variables.user_ids.length,
        'Sent By':         `${userInfo?.first_name} ${userInfo?.last_name}`,
        'Email':           userInfo?.email_id,
        'Company Name':    userInfo?.company_name,
      });
    },
    onError: (error) => {
      const err = error as unknown as API_Error_Type;
      setMessage(err.client_error_msg ?? 'Failed to send announcement');
      setSeverity('error');
      handleSnackbarOpen();
    },
  });
};
